import Form from "components/common/form/Form";
import Input from "components/common/form/inputs/Input";
import {useState} from "react";
import Button from "../../button/Button";
import Translate from "../../Translate";

type OpenByIdModalProps = {
    onOpen: (id: string | number) => void,
    description?: string | undefined | React.ReactNode
}

const OpenByIdModal = (props: OpenByIdModalProps) => {
    const [id, setId] = useState<string>();
    const desc: any = props.description ? props.description : <></>;
    
    const onSubmit = () => {
        props.onOpen(id!)
    }

    return <Form name="openbyid" onSubmit={onSubmit}>
        <Input value={id} autoFocus onChange={setId} label="fields.id.name" required />
        <Button title="button.open" type="submit">
            <Translate i18nKey="button.open" />
        </Button>
        {desc}
    </Form>;
}

export default  OpenByIdModal;
